<template>
   <vue-scroll>
    <bCardRecordHeader :param="param" @on-click-number="getAccountNumberChange"></bCardRecordHeader>

		<div class="open-trades">

			<el-row :gutter="10">
				<el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="8">
					<b>{{$t('records.title')}}{{number}}</b>
				</el-col>
				<el-col class="btn-group" :xs="24" :sm="24" :md="24" :lg="18" :xl="16">
					<div class="start-date">
					<el-date-picker v-model="startDate" @change="getStartDate" format="yyyy-MM-dd" type="date"
						placeholder="START">
					</el-date-picker>
					</div>
					<div class="end-date">
					<el-date-picker v-model="endDate" @change="getEndDate" format="yyyy-MM-dd" type="date"
						placeholder="END">
					</el-date-picker>
					</div>
					<div class="export-btn">
						<el-button class="export-btn-co" type="primary">EXPORT</el-button>
					</div>
				</el-col>
			</el-row>

			<div v-for="(item, index) in newArr01" :key="index" class="trades">
				<div class="head-time">
					<el-row :gutter="10">
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">{{item.nokowntime}}</el-col>
						<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" class="arrow-icon">
							<i :class="{'el-icon-arrow-down': item.isShow == false, 'el-icon-arrow-up': item.isShow == true}" @click="collapseFn(item)"></i>
						</el-col>
					</el-row>
				</div>

				<!-- 页面默认显示部分 -->
				<div class="head-other-item">
					<!-- pc端时 -->
					<el-row :gutter="10" class="hidden-md-and-down">
						<el-col :lg="4" :xl="4"><b>PRODUCT SYMBOL</b><br><span>{{item.productSymbol}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>TYPE</b><br><span>{{item.type}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>SIZE</b><br><span>{{item.size}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>CLOSE PRICE</b><br><span>{{item.closePrice}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>P&amp;L</b><br><span>{{item.pl}}</span></el-col>
					</el-row>
					<!-- 移动端时 -->
					<div class="hidden-lg-and-up">
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>PRODUCT SYMBOL</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.productSymbol}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>TYPE</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.type}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>SIZE</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.size}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>CLOSE PRICE</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.closePrice}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>P&amp;L</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.pl}}</span></el-col>
						</el-row>
					</div>
				</div>
				<!-- 折叠隐藏部分 -->
				<div v-show="item.isShow" class="details">
					<!-- pc端时 -->
					<el-row :gutter="10" class="hidden-md-and-down">
						<el-col :lg="4" :xl="4"><b>ORDER NUMBER</b><br><span>{{item.children.orderNumber}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>OPEN PRICE</b><br><span>{{item.children.openPrice}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>OPEN TIME</b><br><span>{{item.children.openTime}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>CLOSE PRICE</b><br><span>{{item.children.closePrice}}</span></el-col>
						<el-col :lg="8" :xl="8"><b>CLOSE TIME</b><br><span>{{item.children.closeTime}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>S/L</b><br><span>{{item.children.sl}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>T/P</b><br><span>{{item.children.tp}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>SWAP</b><br><span>{{item.children.swap}}</span></el-col>
						<el-col :lg="4" :xl="4"><b>COMMISSION</b><br><span>{{item.children.commission}}</span></el-col>
					</el-row>
					<!-- 移动端时 -->
					<div class="hidden-lg-and-up">
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>ORDER NUMBER</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.orderNumber}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>OPEN PRICE</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.openPrice}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>OPEN TIME</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.openTime}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>CLOSE PRICE</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.closePrice}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>CLOSE TIME</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.closeTime}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>S/L</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.sl}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>T/P</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.tp}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>SWAP</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.swap}}</span></el-col>
						</el-row>
						<el-row :gutter="10">
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4"><b>COMMISSION</b></el-col>
							<el-col :xs="12" :sm="12" :md="12" :lg="4" :xl="4" class="text-right"><span>{{item.children.commission}}</span></el-col>
						</el-row>
					</div>
				</div>
			</div>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage2" :page-sizes="[100, 200, 300, 400]" :page-size="100" layout="sizes, prev, pager, next" :total="1000"></el-pagination>

		</div>
		
	</vue-scroll>
</template>
<script>
export default {
    data () {
        return {
            param: {
                title: 'open_trades',
                links: [
                    {title: 'home'},
                    {title: 'open_trades'}    
                ]
			},
			buttons: [],
			buttonAction: (name) => {
				console.log(name)
			},
			currentPage2: 5,
			number: this.$store.getters.valueAccountNumber,
			search: false,
			startDate: new Date((new Date()).getTime() - 3600 * 1000 * 24 * 7).getTime(),
			endDate: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
			excel: null,

			newArr01: [
				{
					nokowntime: '2018-09-23 14:56:03',
					productSymbol: 'EURUSD',
					type: 'BUY',
					size: '1.01',
					closePrice: '1.15326',
					pl: '6.5',
					isShow: false,
					children: {
						orderNumber: '652665656',	
						openPrice: '1.10202',
						openTime: '2018.08.08 01:06:22',
						closePrice: '2.336',
						closeTime: '2018.11.08 4:12:35',
						sl: '1200',
						tp: '0',
						swap: '-1.22',
						commission: '-15'
					}
				},
				{
					nokowntime: '2018-09-23 14:56:03',
					productSymbol: 'EURUSD',
					type: 'BUY',
					size: '1.01',
					closePrice: '1.15326',
					pl: '6.5',
					isShow: false,
					children: {
						orderNumber: '652665656',	
						openPrice: '1.10202',
						openTime: '2018.08.08 01:06:22',
						closePrice: '2.336',
						closeTime: '2018.11.08 4:12:35',
						sl: '1200',
						tp: '0',
						swap: '-1.22',
						commission: '-15'
					}
				}
			]

		}
	},
	methods:{
		collapseFn: function(item){
			switch (item.isShow){
				case false:
				item.isShow = true;
				break;
				case true:
				item.isShow = false;
				break;
			}
		},
		 getAccountNumberChange(val) {
			//todo
			// this.number = val
			// this.$refs.recordsTab.setPageSize()
			// this.getAllData(val)
		},
		getStartDate(val) {
			this.startDate = val;
			if (!this.startDate) {
			return this.openMessage('error', '请选择开始日期')
			}
			if (!this.endDate) {
			return this.openMessage('error', '请选择结束日期')
			}
			if (new Date(this.endDate) < new Date(this.startDate)) {
			return this.openMessage('error', '结束时间不能小于开始时间')
			}
			this.setPageSize()
			this.$emit('search-fun', [this.startDate, this.endDate])
		},
		getEndDate(val) {
			if (!this.startDate) {
			this.endDate = '';
			return this.openMessage('error', '请选择开始日期')
			}
			if (!this.endDate) {
			return this.openMessage('error', '请选择结束日期')
			}
			
			if (new Date(this.endDate) < new Date(this.startDate)) {
			return this.openMessage('error', '结束时间不能小于开始时间')
			}
			this.endDate = val;
			this.endDate = new Date( // 当天23:59
			new Date(new Date(this.endDate).toLocaleDateString()).getTime() +
			24 * 60 * 60 * 1000 -
			1
			)
			this.setPageSize()
			this.$emit('search-fun', [this.startDate, this.endDate])
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
		}
	},
	mounted() {
      if (this.$store.getters.valueAccountNumber) {
        this.number = this.$store.getters.valueAccountNumber
      }
    }
    
}
</script>
<style lang="scss">
	.open-trades {
		background: #fff;
		padding: 20px;

		.text-right{
			text-align: right;
		}
		
		.head-time{
			border-bottom: 1px solid #ccc;
			padding: 20px;
		}

		.head-other-item{
			padding: 20px;
		}

		.arrow-icon{
			text-align: right;
			color: #fec000;
			cursor: pointer;
		}

		.trades{
			box-shadow: 0 4px 10px #e2e2e2;
			margin-bottom: 20px;
		}

		.details{
			padding: 20px;
			background: #f3f4f6;

			.el-col{
				margin: 10px 0;
			}
		}

		.el-tabs--top {
      margin-top: 30px;
    }

		.btn-group {
			clear: none;

			.start-date {
				float: left;
			}

			.end-date {
				float: left;
				margin-left: 10px;
			}

			.search-date-btn {
				float: left;
				margin-left: 10px;

			}

			.export-btn-co {
				background-color: #192b57;
				border-color: #192b57;
			}

			.export-btn {

				float: right;
			}
		}
	}

  @media (min-width: 490px) and (max-width: 768px) {
    .end-date {
      margin-top: 0 !important;
    }
  }

  @media (max-width: 768px) {
    .open-trades {
      .btn-group {
        clear: none;

        .start-date {
          float: left;
          width: 100%;
          margin-left: 0;

        }

        .end-date {
          float: left;
          margin-top: 20px;
          margin-left: 0 !important;
        }

        .search-date-btn {
          float: left;
          margin-top: 20px;
          width: 100%;
          margin-left: 0;

        }

        .export-btn {
          margin-top: 20px;
          width: 100%;
          float: left !important;
        }
      }
    }
  }

  @media (max-width: 908px) {
    .open-trades {
      .btn-group {
        clear: none;

        .start-date {
          float: left;
          width: 50%;
        }

        .end-date {
          float: left;
          margin-left: 10px;
        }

        .search-date-btn {
          float: left;
          margin-top: 20px;
          width: 50%;
          margin-left: 0;

        }

        .export-btn {
          margin-top: 20px;
          width: 50%;

          float: left !important;
        }
      }
    }
  }
</style>